var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTememplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "M14.5714 12.4286C14.5714 13.2953 13.8667 14 13 14H3.5714C2.7047 14 2 13.2953 2 12.4286V4.5714C2 3.7047 2.7047 3 3.5714 3h3.1429c.4935 0 .96.2333 1.2571.6286l.4715.6285a.78.78 0 0 0 .6285.3143H13c.8667 0 1.5714.7047 1.5714 1.5715zm-6.875-.9822a.588.588 0 0 0 .5893.5893.588.588 0 0 0 .5893-.5893V9.875h1.5714a.588.588 0 0 0 .5893-.5893.588.588 0 0 0-.5893-.5893H8.875V7.125a.588.588 0 0 0-.5893-.5893.588.588 0 0 0-.5893.5893v1.5714H6.125a.588.588 0 0 0-.5893.5893c0 .3266.2627.5893.5893.5893h1.5714z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTememplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tememplate.134516f70d8038b851a38e0959aea99d.svg";